import { render, staticRenderFns } from "./report-result-box.vue?vue&type=template&id=00544902&scoped=true&"
import script from "./report-result-box.vue?vue&type=script&lang=js&"
export * from "./report-result-box.vue?vue&type=script&lang=js&"
import style0 from "./report-result-box.vue?vue&type=style&index=0&id=00544902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00544902",
  null
  
)

export default component.exports